export default __webpack_public_path__ + "static/color-picker-avoid-yellow-text-do-537d33ab2526f8ee239e2d13eb759376ac9ab002f4cf397bbdd1ca09e01d45da.png";